import { render, staticRenderFns } from "./app-message.vue?vue&type=template&id=5726e600&scoped=true&"
import script from "./app-message.vue?vue&type=script&lang=js&"
export * from "./app-message.vue?vue&type=script&lang=js&"
import style0 from "./app-message.vue?vue&type=style&index=0&id=5726e600&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5726e600",
  null
  
)

export default component.exports